module.exports = __webpack_public_path__ + "img/ouboli.5570518d.webp";